window.aguadecoco = window.aguadecoco || {};

function Acordion() {
  const $document = $(document);

  const init = () => {
    getAcordins();
  };

  const getAcordins = () => {
    const $acordions = $('[data-widget="acordion"]');
    $acordions.each((_, e) => handleAcordion(e));
  };

  const handleAcordion = (e: HTMLElement) => {
    const $e = $(e);
    const dataResolution = $e.data('acordion-resolution');
    const resolution = dataResolution === 'full' || window.innerWidth <= parseInt(dataResolution.replace('px', ''));

    const $shouldStartOpen = $e.data('default-open');

    if ($shouldStartOpen) {
      const $target = $e.data('acordion-target');
      const $from = $document.find(`[data-acordion-from=${$target}]`);
      $from?.slideDown({
        duration: 0,
      });
      $from?.addClass('acordion-active');
      $e?.addClass('acordion-active');
    }

    if (!resolution) return;

    $e.on('click', () => {
      const $target = $e.data('acordion-target');
      const $from = $document.find(`[data-acordion-from=${$target}]`);
      const $isActive = $e.hasClass('acordion-active');

      if ($isActive) {
        $from?.slideUp();
        $from?.removeClass('acordion-active');
        $e?.removeClass('acordion-active');
        return;
      }

      $from?.slideDown();
      $from?.addClass('acordion-active');
      $e?.addClass('acordion-active');
    });
  };

  init();
}
new Acordion();

Object.assign(window.aguadecoco, {
  helpers: Object.assign(window.aguadecoco.helpers || {}, { Acordion:  Acordion }),
});

export default {};
